<template>
  <va-edit-layout :actions="['list', 'show', 'delete']">
    <commodity-farms-form
      :id="id"
      :title="title"
      :item="item"></commodity-farms-form>
  </va-edit-layout>
</template>

<script>
export default {
  props: ['id', 'title', 'item'],
}
</script>
